import { cn } from '@anytag/shared-utils';
import { NoDataWrapper, NoDataWrapperProps } from './NoDataWrapper';

export type NoDataContentWrapperProps = NoDataWrapperProps;
export const NoDataContentWrapper = ({ className, ...restProps }: NoDataContentWrapperProps) => (
  <NoDataWrapper
    wrapperText="The system is collecting data, please wait until the data is ready"
    className={cn(
      'flex h-full min-h-75 flex-col overflow-hidden rounded-none border-none bg-white p-0 shadow-none',
      className
    )}
    {...restProps}
  />
);
